import Quill from "quill";

export default (elementID, options = { maxChars: null, blockOnExceed: false }) => ({
    quill        : null,
    maxChars     : options.maxChars ?? null,
    blockOnExceed: options.blockOnExceed ?? false,
    charCounter: 0,

    _editorRef: null,

    get charExceeded(){
        if (this.maxChars === null) {
            return false;
        }

        return this.countChars() > this.maxChars;
    },

    init(){
        const toolbar     = this.$el.getAttribute('data-quill-toolbar');
        const placeholder = this.$el.getAttribute('data-quill-placeholder');

        const qOptions = {
            theme      : 'snow',
            placeholder: placeholder ?? 'Contenido de la nota...',
            modules: {
                toolbar: toolbar ?? true,
            },
            // debug: 'info',
        }

        this.quill = new Quill(`#${ elementID }`, qOptions);
        this._editorRef = this.$refs.editor.firstChild;
        this._editorRef.setAttribute('x-bind', 'editable');

        if (this._editorRef.innerHTML.trim() !== '') {
            this.onChange();
        }
    },

    onChange(){
        // debugger;
        this.charCounter = this.countChars();
        const html = this.quill.getSemanticHTML();
        // const text = this.quill.getText();

        this.$dispatch('text-editor:change', {
            content: html,
            id: elementID
        });
    },

    setContent({ editorID, value }){
        // debugger;
        if(editorID !== elementID) return;
        this._editorRef.innerHTML = value;
        this.$nextTick(() => {
            // this.quill.setContents(this.quill.clipboard.convert(this._editorRef.innerHTML));
            this.onChange();
        });
        // this._editorRef.dispatchEvent(new Event('input'));
    },

    countChars() {
        // Por alguna razón el quill agrega un caracter vacío al final del texto y cuenta como un caracter más
        return this.quill.getText().length -1;
    },

    editable: {
        ['@input'](){
            this.onChange();
        },
        ['@focusout'](){
            this.onChange();
        }
    }
});
